import { render, staticRenderFns } from "./YesNoDialog.vue?vue&type=template&id=40ed69fa&scoped=true"
import script from "./YesNoDialog.vue?vue&type=script&lang=ts"
export * from "./YesNoDialog.vue?vue&type=script&lang=ts"
import style0 from "./YesNoDialog.vue?vue&type=style&index=0&id=40ed69fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ed69fa",
  null
  
)

export default component.exports